import React, { useState, useEffect } from 'react'
import { TopBar, TopBarSection, TopBarTitle } from '@duik/it'
import MainContainer from '../UI/MainContainer'
import TableContainer from '../UI/TableContainer'
import TableSection from '../UI/TableSection'
import TopBarMenuDivider from '../UI/TopBarMenuDivider'
import LoadingIcon from '../components/LoadingIcon'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { setSnackBarCopy, toggleSnackBar } from '../UI/Store/actions'
import { getReport, clearReport } from './Store/actions'
import moment from 'moment'
import Snackbar from '../UI/Snackbar'
import ExpandableLine from './Components/ExpandableLine'
import ExpandableDriver from './Components/ExpandableDriver'
import {
  ReportDetailContainer,
  TopContainer,
  TopContainerText,
  TopWrapper,
  ReportDetailInfoContainer,
  ReportDetailInfoText,
  GreyText,
  MainReportContainer,
  MainReportDetailContainer,
  MainReportDetailText,
  MainReportDetail,
  MainReportDetails,
  MainReportDetailsText,
  ReportDetailInfoWrapper,
  ExpandableLineContainer,
  StyledExpandLessIcon,
  StyledExpandMoreIcon,
  DriverContainer,
  DriverText,
  ExpandableLineWrapper,
  StyledTopBar
} from './styles'

const ReportDetail = props => {
  const [driversExpanded, setDriversExpanded] = useState(false)
  const truckTypes = ['Single', 'Tandem', 'Tri-axle', 'End Dump']

  useEffect(() => {
    props.getReport(props.match.params.id)
    return () => {
      props.clearReport()
    }
  }, []) //eslint-disable-line

  const getTotalQuantity = loads => {
    let total = 0
    loads.forEach(item => {
      if (item.quantity !== '' && !isNaN(item.quantity)) {
        total = total + Number(item.quantity)
      }
      return
    })
    return total
  }

  const getTotalTimeMinutes = loads => {
    let hours = 0
    loads.forEach(item => {
      const time = moment(moment(item.departTimeB)).diff(moment(item.arriveTimeA), 'minutes')
      if (!isNaN(time)) {
        hours = hours + time
      }
      return
    })
    return hours
  }

  const { reportDetail } = props.reports
  if (props.reports.loading || !props.reports.reportDetail) {
    return <div />
  }

  let numOfTrucks = reportDetail.haulLogs.map(item => item.driverId)
  numOfTrucks = [...new Set(numOfTrucks)].length

  const truckHours = getTotalTimeMinutes(reportDetail.haulLogs)

  const importHauls = reportDetail.hauls.filter(item => item.haulType === 'import')
  const importLoads = reportDetail.haulLogs.filter(item =>
    importHauls.map(item => item.haulId).includes(item.haulId)
  )

  const importMaterialsAmount = getTotalQuantity(importLoads)

  let importMaterials = importHauls.map(item => item.material)

  importMaterials = [...new Set(importMaterials)]

  const exportHauls = reportDetail.hauls.filter(item => item.haulType === 'export')
  const exportLoads = reportDetail.haulLogs.filter(item =>
    exportHauls.map(item => item.haulId).includes(item.haulId)
  )
  const exportMaterialsAmount = getTotalQuantity(exportLoads)

  let exportMaterials = exportHauls.map(item => item.material)
  exportMaterials = [...new Set(exportMaterials)]

  const topReportDetails = [
    { title: 'Company', text: props.userCompany },
    { title: 'Projects', text: reportDetail.projects.map(item => item.projectName).join(', ') },
    { title: 'Hauls', text: reportDetail.hauls.map(item => item.haulId).join(', ') }
  ]

  const mainReportDetails = [
    { title: 'Loads', text: reportDetail.haulLogs.length },
    { title: 'Trucks', text: numOfTrucks },
    { title: 'Trucking Hours', text: (truckHours / 60).toFixed(1) }
  ]

  const lineReportDetails = [
    {
      title: 'Loads In',
      text: `${importLoads.length} `,
      lineExpandedData: importHauls,
      renderExpandedTitle: importHauls =>
        `${importHauls.pickUpSite.siteName} > ${importHauls.dropOffSite.siteName}`,
      renderExpandedText: importHauls =>
        importLoads.filter(load => load.haulId === importHauls.haulId).length,
      renderDriverText: driverId => importLoads.filter(item => item.driverId === driverId).length,
      renderDriverExpandedText: (importHauls, driverId) =>
        importLoads.filter(load => load.haulId === importHauls.haulId && load.driverId === driverId)
          .length
    },
    {
      title: 'Materials Imported',
      text: `${importMaterialsAmount} `,
      lineExpandedData: importMaterials,
      renderExpandedTitle: importMaterials => importMaterials,
      renderExpandedText: importMaterials =>
        getTotalQuantity(importLoads.filter(load => load.material === importMaterials)),
      renderDriverText: driverId =>
        getTotalQuantity(importLoads.filter(item => item.driverId === driverId)),
      renderDriverExpandedText: (importMaterials, driverId) =>
        getTotalQuantity(
          importLoads.filter(
            load => load.driverId === driverId && load.material === importMaterials
          )
        )
    },
    {
      title: 'Loads Out',
      text: `${exportLoads.length} `,
      lineExpandedData: exportHauls,
      renderExpandedTitle: exportHauls =>
        `${exportHauls.pickUpSite.siteName} > ${exportHauls.dropOffSite.siteName}`,
      renderExpandedText: exportHauls =>
        exportLoads.filter(load => load.haulId === exportHauls.haulId).length,
      renderDriverText: driverId => exportLoads.filter(item => item.driverId === driverId).length,
      renderDriverExpandedText: (exportHauls, driverId) =>
        exportLoads.filter(load => load.haulId === exportHauls.haulId && load.driverId === driverId)
          .length
    },
    {
      title: 'Materials Exported',
      text: `${exportMaterialsAmount} `,
      lineExpandedData: exportMaterials,
      renderExpandedTitle: exportMaterials => exportMaterials,
      renderExpandedText: exportMaterials =>
        getTotalQuantity(exportLoads.filter(load => load.material === exportMaterials)),
      renderDriverText: driverId =>
        getTotalQuantity(exportLoads.filter(item => item.driverId === driverId)),
      renderDriverExpandedText: (exportMaterials, driverId) =>
        getTotalQuantity(
          exportLoads.filter(
            load => load.driverId === driverId && load.material === exportMaterials
          )
        )
    },
    {
      title: 'Trucking Hours',
      text: `${(getTotalTimeMinutes(reportDetail.haulLogs) / 60).toFixed(1)} `,
      lineExpandedData: truckTypes,
      renderExpandedTitle: truckType => truckType,
      renderExpandedText: truckType =>
        (
          getTotalTimeMinutes(
            reportDetail.haulLogs.filter(log => log.driver.truckType === truckType)
          ) / 60
        ).toFixed(1),
      renderDriverText: driverId =>
        (
          getTotalTimeMinutes(reportDetail.haulLogs.filter(item => item.driverId === driverId)) / 60
        ).toFixed(1),
      renderDriverExpandedText: (truckType, driverId) =>
        (
          getTotalTimeMinutes(
            reportDetail.haulLogs.filter(
              log => log.driverId === driverId && log.driver.truckType === truckType
            )
          ) / 60
        ).toFixed(1)
    }
  ]

  return (
    <MainContainer>
      <TopContainer>
        <TopBar>
          <TopBarSection>
            <TopContainerText className="uik-top-bar-title__wrapper">
              Reports &gt; {props.reports.reportDetail.name}
            </TopContainerText>
          </TopBarSection>
        </TopBar>
      </TopContainer>
      <TableContainer>
        <TopWrapper className="uik-widget-content__wrapper">
          <StyledTopBar>
            <TopBarTitle>{props.reports.reportDetail.name}</TopBarTitle>
            <TopBarMenuDivider />
            {props.reports.loading && <LoadingIcon />}
          </StyledTopBar>
        </TopWrapper>

        <TableSection>
          {!props.reports.loading && props.reports.reportDetail && (
            <>
              <ReportDetailInfoWrapper>
                <ReportDetailContainer>
                  <ReportDetailInfoContainer>
                    <div>
                      <ReportDetailInfoText>Date</ReportDetailInfoText>
                    </div>
                    <div>
                      <GreyText>
                        {moment(props.reports.reportDetail.startDateTime).format('MMM DD YYYY')} -{' '}
                        {moment(props.reports.reportDetail.endDateTime).format('MMM DD YYYY')}
                      </GreyText>
                    </div>
                  </ReportDetailInfoContainer>

                  {topReportDetails.map(item => (
                    <ReportDetailInfoContainer>
                      <div>
                        <ReportDetailInfoText>{item.title}</ReportDetailInfoText>
                      </div>
                      <div>
                        <GreyText>{item.text}</GreyText>
                      </div>
                    </ReportDetailInfoContainer>
                  ))}
                </ReportDetailContainer>
              </ReportDetailInfoWrapper>
              <div>
                <ReportDetailContainer>
                  <MainReportContainer>
                    {mainReportDetails.map(item => (
                      <MainReportDetailContainer>
                        <MainReportDetail>
                          <MainReportDetailText>{item.title}</MainReportDetailText>
                        </MainReportDetail>
                        <MainReportDetails>
                          <MainReportDetailsText>{item.text}</MainReportDetailsText>
                        </MainReportDetails>
                      </MainReportDetailContainer>
                    ))}
                  </MainReportContainer>
                </ReportDetailContainer>
              </div>
              <div>
                <ExpandableLineContainer>
                  {lineReportDetails.map(item => (
                    <ExpandableLine
                      title={item.title}
                      text={item.text}
                      data={item.lineExpandedData}
                      renderExpandedTitle={item.renderExpandedTitle}
                      renderExpandedText={item.renderExpandedText}
                    />
                  ))}
                </ExpandableLineContainer>
              </div>

              <DriverContainer>
                <DriverText>
                  {driversExpanded ? (
                    <StyledExpandLessIcon onClick={() => setDriversExpanded(false)} />
                  ) : (
                    <StyledExpandMoreIcon onClick={() => setDriversExpanded(true)} />
                  )}{' '}
                  Drivers
                </DriverText>
                {driversExpanded &&
                  reportDetail.drivers.map(item => (
                    <ExpandableDriver driverName={`${item.firstName} ${item.lastName}`}>
                      <div>
                        <ExpandableLineWrapper>
                          {lineReportDetails.map(lineItem => {
                            return (
                              <ExpandableLine
                                title={lineItem.title}
                                text={lineItem.text}
                                data={lineItem.lineExpandedData}
                                renderExpandedTitle={lineItem.renderExpandedTitle}
                                renderDriverText={lineItem.renderDriverText}
                                renderDriverExpandedText={lineItem.renderDriverExpandedText}
                                driverId={item._id}
                              />
                            )
                          })}
                        </ExpandableLineWrapper>
                      </div>
                    </ExpandableDriver>
                  ))}
              </DriverContainer>
            </>
          )}
        </TableSection>
      </TableContainer>
      {props.snackBarVisible && <Snackbar text={props.snackBarCopy} />}
    </MainContainer>
  )
}

const mapStateToProps = state => {
  return {
    reports: state.reports,
    snackBarCopy: state.ui.snackBarCopy,
    snackBarVisible: state.ui.snackBarVisible,
    loading: state.reports.loading,
    userCompany: state.user.userData.companyName
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getReport,
      clearReport,
      setSnackBarCopy,
      toggleSnackBar
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(ReportDetail)
